import { observer } from "mobx-react";
import { useEffect, useState } from "react";
import toast from "react-hot-toast";
import { useGlobalStore } from "../../api/globalStores";
import { definitions } from "../../api/supabase/client";
import Modal from "../../Common/Utility/Modal";
import { getEventDay } from "../../util/getEventMonth";
import { FeedbackColumns } from "../Components/Table/FeedbackColumns";
import Table, { IFeedbackDataRow } from "../Components/Table/Table";
import TeacherFeedbackForm from "../Components/TeacherFeedbackForm";

export interface IStudentFeedbackPage {}

//TODO: Make sure the page is updated after the feedback is filled in, etc
export default observer(StudentFeedbackPage);

function StudentFeedbackPage() {
  const [openTeacherFeedback, setOpenTeacherFeedback] = useState(false);
  const [teacherFeedbacks, setTeacherFeedbacks] = useState<
    Awaited<ReturnType<typeof globalStores.teacherStore.getTeacherFeedbacks>>
  >([]);
  const globalStores = useGlobalStore();

  useEffect(() => {
    if (globalStores.teacherStore.teacherAccount.id) {
      const run = async () => {
        const feedbacks = await globalStores.teacherStore.getTeacherFeedbacks();
        setTeacherFeedbacks(feedbacks);
      };

      run();
    }
  }, [globalStores.teacherStore.teacherAccount.id]);

  const studentFeedbackData: IFeedbackDataRow[] = teacherFeedbacks.map(
    (teacherFeedback) => {
      if (!teacherFeedback.TalkingPartyRoom?.startTime) {
        throw new Error("Expected talking party room to have start time!");
      }

      const startDateTime = new Date(
        teacherFeedback.TalkingPartyRoom.startTime
      );
      return {
        level: 1,
        day: getEventDay(startDateTime),
        date: startDateTime.toLocaleDateString(),
        timeslot: startDateTime.toLocaleTimeString([], {
          hour: "2-digit",
          minute: "2-digit",
        }),
        assigned_teacher:
          teacherFeedback.TalkingPartyRoom.TimeSlot?.Class?.ClassTeacher[0]
            ?.TeacherAccount?.StaffDetails?.displayName ??
          "No Assigned Teacher",
        class_id: teacherFeedback.TalkingPartyRoom.TimeSlot?.Class?.id,
        progress: teacherFeedback.engagementImprovementPlan
          ? "Done"
          : "In Progress",
        originalFeedback: teacherFeedback,
      };
    }
  );

  const handleOpenFeedback = async (row: any) => {
    await globalStores.curTalkingParty.init(
      row.originalFeedback.TalkingPartyRoom.id
    );
    await globalStores.curClass.init(
      row.originalFeedback.TalkingPartyRoom.TimeSlot.Class.id
    );
    setOpenTeacherFeedback(true);
  };

  return (
    <>
      <Modal
        open={openTeacherFeedback}
        onClose={() => {
          setOpenTeacherFeedback(false);
        }}
      >
        <TeacherFeedbackForm
          formTriggerLocation="StudentFeedbackPage"
          onSubmit={async () => {
            setOpenTeacherFeedback(false);
            const feedbacks =
              await globalStores.teacherStore.getTeacherFeedbacks();
            setTeacherFeedbacks(feedbacks);
          }}
        />
      </Modal>
      <div className="flex flex-col gap-6 text-left h-full">
        <div className="flex text-heading1 font-semibold">Student Feedback</div>
        <Table
          rowData={studentFeedbackData}
          colData={FeedbackColumns as any}
          onClickRow={(row) =>
            toast.promise(handleOpenFeedback(row), {
              success: "Feedback Loaded",
              loading: "Loading Feedback",
              error: (e) => e.message,
            })
          }
        />
      </div>
    </>
  );
}
